import { Observable } from 'rxjs';

/**
 * @description Interface used to support application internationalization
 */
export abstract class AppTranslationGateway {
  /**
   * Method to get a translation asynchronously
   * @param key translation key
   * @param params extra translation parameters
   * @returns translation
   * */
  abstract getAsync(
    key: string,
    params?: Record<string, string>
  ): Observable<string>;

  /**
   * Method to get a translation synchronously
   * @param key translation key
   * @param params extra translation parameters
   * @returns translation
   * */
  abstract get(key: string, params?: Record<string, string>): string;
}
